module.exports = __webpack_public_path__ + "img/sem_emissoes.d8250dd1.svg";